<template>
  <v-row no-gutters>
    <v-row no-gutters>
      <base-cvc-funnel-chart
        v-if="action.feedback"
        class="mx-auto fade-in"
        :width="700"
        :height="225"
        :labels="funnelFieldHeaders"
        :colors="[
          [
            $vuetify.theme.currentTheme.colorGradient1A,
            $vuetify.theme.currentTheme.colorGradient1B,
          ],
        ]"
        :values="funnelFieldValues"
        direction="horizontal"
        gradient-direction="horizontal"
        :key="action.action_id"
      />
    </v-row>

    <v-row class="notification-details-wrapper">
      <v-col cols="6">
        <div class="header">Time sent</div>
        <div class="text">{{ humanTimestamp }}</div>
        <div class="header">Sender</div>
        <div class="text">{{ action.sender ? action.sender : "Unknown" }}</div>
        <div class="header">Segment</div>
        <div class="text"
        >{{
            action.profile_display_name
              ? action.profile_display_name
              : "All users"
          }}
        </div>
        <div class="header">Trigger</div>
        <div
          class="text"
          v-if="X.action.type === 'AbsoluteCalendarNotification' || X.action.type === 'InstantNotification'"
        >This notification was scheduled to  arrive at  <span class="highlight">{{ formatDate(X.action.args.absolute.$date) }}</span>
        </div>
        <div class="text" v-if="X.action.type === 'ArrivalNotification'"
        >This notification was scheduled to show when the user <span class="highlight">arrived at
          {{ X.action.args.set_id }}</span>
        </div>
        <div class="text" v-if="X.action.type === 'DepartureNotification'"
        >This notification was scheduled to show when the user was <span class="highlight">leaving
          {{ X.action.args.set_id }}</span>
        </div>
      </v-col>

      <v-col cols="6">
        <div class="header">Title</div>
        <div class="text">{{ payload.title }}</div>
        <div class="header">Message</div>
        <div class="text"
        >{{ payload.message ? payload.message : "(Not specified)" }}
        </div>
        <div class="header">Image URL</div>
        <div class="text">
          <code v-if="payload.image">{{ payload.image }}</code>
          <template v-else>(Not specified)</template>
        </div>
        <div class="header">Deep Link</div>
        <div class="text">
          <code v-if="payload.deep_link">{{ payload.deep_link }}</code>
          <template v-else>(Not specified)</template>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col
        cols="6"
        v-for="(fieldsByColumn, i) in configurationFieldsByColumn"
        class="pt-0"
        :key="`notification-performance-field-column-${i}`"
      >
        <v-row
          v-for="(field, j) in fieldsByColumn"
          :key="`notification-performance-field-${i}-${j}`"
          class="mt-4"
        >
          <span>
            <v-text-field
              class="mt-2 mb-2"
              required
              dense
              readonly
              hide-details
              :label="field.header"
              v-model="field.value"
            />
          </span>
        </v-row>
      </v-col>
    </v-row> -->
    <!-- <v-row>
      <v-col>
        <v-row v-if="action.notification.calendar_action">
          This notification was scheduled to arrive at
          {{ action.notification.calendar_action.absolute }}
        </v-row>
        <v-row v-if="action.notification.journey_action">
          This notification was scheduled to arrive at
          {{ action.notification.journey_action.set_id }} when the user was
          {{ action.notification.journey_action.direction }}
        </v-row>
      </v-col>
    </v-row> -->
  </v-row>
</template>

<script>
import BaseCvcFunnelChart from "@/components/CvcCharts/BaseCvcFunnelChart";
import { parseISO } from "date-fns";

export default {
  name: "NotificationPerformanceReport",
  components: {
    BaseCvcFunnelChart,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      funnelFieldHeaders: ["Expected", "Sent"],
    };
  },
  methods: {
    formatTimestamp(ts) {
      return this.formatDate(parseISO(ts));
    },
    formatDate(ms) {
      return "" + new Date(ms);
    },
  },
  computed: {
    X() {
      return this.action.action;
    },
    humanTimestamp() {
      const timestamp = this.action?.time_sent;
      if (timestamp) {
        return this.formatTimestamp(timestamp);
      }
      return null;
    },
    funnelFieldValues() {
      return [
        [this.action.feedback.total || 0],
        [this.action.feedback.sent || 0],
        // [this.action.feedback.displayed || 0],
        // [this.action.feedback.clicked || 0],
      ];
    },
    matrixFieldValues() {
      return [this.action.feedback];
    },
    payload() {
      return this.X.action.payload;
    },
  },
};
</script>

<style lang="scss">
.notification-performance-report {
  .label__value {
    font-size: 20px !important;
  }
  .svg-funnel-js__label {
    padding-left: 8px !important;
  }
}
.notification-details-wrapper {
  width: 100%;
}

.header {
  display: flex;
  font-size: 1.1rem;
  font-weight: 500;
}

.text {
  display: block;
  font-size: 0.875rem;
  margin-bottom: 1em;
  white-space: break-spaces;
}

.highlight {
  font-weight: bold;
  display: block;
}
</style>
